import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getTwoFAPath = () => {
  return urlHelper('/auth/2fa');
};
